import { loadStripe } from '@stripe/stripe-js';
import { stripePublishableKey } from '@/config';

const getStripeKeyMode = (key: string) => {
  if (key.startsWith('pk_live_')) return 'live';
  if (key.startsWith('pk_test_')) return 'test';
  return 'unknown';
};

const createStripePromise = () => {
  if (!stripePublishableKey) {
    console.error('[billing] Stripe.js was not initialized because its configuration is missing.');
    return null;
  }

  const keyMode = getStripeKeyMode(stripePublishableKey);
  console.debug('[billing] Initializing Stripe.js.', { keyMode });

  return loadStripe(stripePublishableKey).then(
    (stripe) => {
      if (stripe) {
        console.debug('[billing] Stripe.js initialized successfully.', { keyMode });
      } else {
        console.error('[billing] Stripe.js initialization returned no Stripe instance.', {
          keyMode,
        });
      }

      return stripe;
    },
    (error: unknown) => {
      console.error('[billing] Stripe.js failed to initialize.', { keyMode, error });
      return null;
    },
  );
};

export const stripePromise = createStripePromise();
